export const AUTH_CONFIG = {
  domain: 'dev-platewiz-123.auth0.com',
  clientId: 'DySXD69eHvMs56Fbd700BmkZkAXENKC7',
  //callbackUrl: 'http://localhost:3000/callback'
  //callbackUrl: 'http://34.229.118.233:3700/callback'
}


//callbackUrl: 'http://localhost:3000/callback'
//callbackUrl: 'http://34.229.118.233:3700/callback'
//callbackUrl: 'http://localhost:3000/callback'

//callbackUrl: 'http://34.229.118.233:3700/callback'
//callbackUrl: 'http://34.229.118.233:3700/callback'
